import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { MediaWrapper } from './MediaWrapper';
import { getAspectRatioForEmbed } from '../utils';
export const RichMedia = ({ aspectRatio: aspectRatioProp, embed }) => {
    const { html } = embed;
    const aspectRatio = aspectRatioProp !== null && aspectRatioProp !== void 0 ? aspectRatioProp : getAspectRatioForEmbed(embed);
    return (_jsx(MediaWrapper, { "$aspectRatio": aspectRatio, children: _jsx(RichContent, { dangerouslySetInnerHTML: { __html: html } }) }));
};
const RichContent = styled(Box) `
  display: block;
  text-align: center;
  width: 100%;
  height: 100%;

  iframe {
    width: 100%;
    height: 100%;
  }
`;
//# sourceMappingURL=RichMedia.js.map